import React from 'react';
import {View} from 'react-native';
import isNil from 'lodash/isNil';

import sy from '~/styles';
import {
  Pressable,
  MoreMenu,
  ServiceRequestStatusIcon,
} from '~/components/controls';
import {
  fleet as fleetApi,
  rob as robApi,
  service_request as serviceRequestApi,
} from '~/api/private';
import {isLessorStatus, isInvoiced, isArchived} from '~/types/rob';
import {STATUS_CODES} from '~/types/statuses';

import MoreVertIcon from '~/images/md-icons/more_vert/materialicons/24px.svg';
import PropTypes from 'prop-types';

const renderCancelledStatusIcon = () => (
  <ServiceRequestStatusIcon fill="#4a4a49" status={STATUS_CODES.Cancelled} />
);

const HeaderRight = ({
  request_id,
  replacement,
  rob,
  fleetRequest,
  onEditType,
  onShowRobDenials,
  onRefresh,
}) => {
  if (fleetRequest || rob?.rob_id) {
    const {status} = fleetRequest ?? replacement ?? {};

    const menuItems = [
      [
        STATUS_CODES.ProvisionallyApproved,
        STATUS_CODES.ReplacementReservationApproved,
        STATUS_CODES.ReplacementCheckoutApproved,
        STATUS_CODES.ReplacementExtensionApproved,
        STATUS_CODES.Approved,
        STATUS_CODES.Denied,
      ].includes(status) && {
        title: 'Activiteit naar vervallen',
        leadingIcon: renderCancelledStatusIcon,
        onPress: async () => {
          try {
            if (fleetRequest) {
              await fleetApi.cancel_replacement_vehicle(request_id);
            } else {
              await robApi.cancel_replacement_vehicle(request_id);
            }
          } catch {}

          await onRefresh();
        },
      },
    ].filter(Boolean);

    return (
      <View
        style={[sy['flex-row'], sy['items-center'], sy['gap-2'], sy['mr-4']]}>
        <Pressable
          disabled={
            isLessorStatus(status) ||
            [STATUS_CODES.Done, STATUS_CODES.DoneNoInvoice].includes(status) ||
            isInvoiced(status) ||
            isArchived(status)
          }
          onPress={onShowRobDenials}>
          <ServiceRequestStatusIcon status={status} />
        </Pressable>
        {menuItems.length > 0 && <MoreMenu items={menuItems} />}
      </View>
    );
  }

  if (
    !isNil(request_id) &&
    !isNil(replacement?.request_id) &&
    request_id === replacement?.request_id
  ) {
    const menuItems = [
      [STATUS_CODES.Draft].includes(replacement?.status) && {
        title: 'Opdracht annuleren',
        leadingIcon: renderCancelledStatusIcon,
        onPress: async () => {
          await serviceRequestApi.change_status(
            replacement?.request_id,
            STATUS_CODES.Cancelled,
          );

          await onRefresh();
        },
      },
    ].filter(Boolean);

    return (
      <View
        style={[sy['flex-row'], sy['items-center'], sy['gap-2'], sy['mr-4']]}>
        <ServiceRequestStatusIcon status={replacement?.status} />
        {menuItems.length > 0 && <MoreMenu items={menuItems} />}
      </View>
    );
  }

  return (
    <Pressable
      style={{marginHorizontal: 11, marginVertical: 3}}
      onPress={onEditType}>
      <MoreVertIcon />
    </Pressable>
  );
};
HeaderRight.propTypes = {
  request_id: PropTypes.any,
  replacement: PropTypes.any,
  rob: PropTypes.any,
  fleetRequest: PropTypes.any,
  onEditType: PropTypes.any,
  onShowRobDenials: PropTypes.any,
  onRefresh: PropTypes.any,
};

export default HeaderRight;
